import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { EventsApiService, eventsQueryKeys, postpondDTO } from 'features/events';
import { queryClient } from 'providers';


const { updatePostpond } = EventsApiService();

export const useUpdatePostPosnd = () => {
    const { message } = App.useApp();

    return useMutation(
        (payload:postpondDTO) => {
            return updatePostpond(payload);
        },
        {
            onError: (error) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
                message.success("PostPond updated successfully!!");
            },
        },
    );
};